export default {
  enable_website_banner: false,
  enable_docsnav_banner: false,
  enable_job_banner: false,
};
